var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.666L14 5.33262C13.9998 5.0988 13.938 4.86916 13.821 4.66673C13.704 4.4643 13.5358 4.29619 13.3333 4.17929L8.66667 1.51262C8.46398 1.39559 8.23405 1.33398 8 1.33398C7.76596 1.33398 7.53603 1.39559 7.33334 1.51262L2.66667 4.17929C2.46418 4.29619 2.29599 4.4643 2.17897 4.66673C2.06196 4.86916 2.00024 5.0988 2 5.33262L2 10.666C2.00024 10.8998 2.06196 11.1294 2.17897 11.3318C2.29599 11.5343 2.46418 11.7024 2.66667 11.8193L7.33334 14.486C7.53603 14.603 7.76596 14.6646 8 14.6646C8.23405 14.6646 8.46398 14.603 8.66667 14.486L13.3333 11.8193C13.5358 11.7024 13.704 11.5343 13.821 11.3318C13.938 11.1294 13.9998 10.8998 14 10.666Z",
    stroke: "#141414",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17969 4.64062L7.99969 8.00729L13.8197 4.64062",
    stroke: "#141414",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.72V8",
    stroke: "#141414",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon_box.3a36bc9c1f191faf6f964abcfa4efc03.svg";
export { ForwardRef as ReactComponent };